import React from 'react'
import PropTypes from 'prop-types'
import {DatePicker, TimePicker} from 'antd'
import {ClockCircleOutlined} from '@ant-design/icons'
import moment from 'moment'
import TextRenderWidth from 'components/shared/TextRenderWidth'

import './index.css'

class DateTimeRange extends React.Component {
  // Disable dates before current week
  disabledStartDate = (current) => {
    return current && current < moment().startOf('week')
  }

  // Disable dates outside of start's week
  disabledEndDate = (current) => {
    return current && this.props.start && current.isoWeek() !== this.props.start.isoWeek()
  }

  render() {
    const {start, end, onChange} = this.props

    return (
      <div className="date-time-range">
        <ClockCircleOutlined />

        <div className="date-time-fields">
          <TextRenderWidth buffer={8} text={start.format('ll')}>
            {width => (
              <DatePicker
                showToday={false}
                allowClear={false}
                format="ll"
                value={start}
                onChange={(start) => onChange({start})}
                disabledDate={this.disabledStartDate}
                style={{width}}
              />
            )}
          </TextRenderWidth>

          <TextRenderWidth buffer={8} text={start.format('HH:mm')}>
            {width => (
              <TimePicker
                allowClear={false}
                format="HH:mm"
                minuteStep={15}
                value={start}
                onChange={(start) => onChange({start})}
                style={{width}}
              />
            )}
          </TextRenderWidth>

          {' - '}

          <TextRenderWidth buffer={8} text={end.format('HH:mm')}>
            {width => (
              <TimePicker
                allowClear={false}
                format="HH:mm"
                minuteStep={15}
                value={end}
                onChange={(end) => onChange({end})}
                style={{width}}
              />
            )}
          </TextRenderWidth>

          <TextRenderWidth buffer={8} text={end.format('ll')}>
            {width => (
              <DatePicker
                showToday={false}
                allowClear={false}
                format="ll"
                value={end}
                onChange={(end) => onChange({end})}
                disabledDate={this.disabledEndDate}
                style={{width}}
              />
            )}
          </TextRenderWidth>
        </div>
      </div>
    )
  }
}

DateTimeRange.propTypes = {
  start: PropTypes.object.isRequired,
  end: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default DateTimeRange
